// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeTypename = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename);
  } else if (obj !== null && typeof obj === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { __typename, ...rest } = obj;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return Object.keys(rest).reduce(
      (acc, key) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        acc[key] = removeTypename(rest[key]);
        return acc;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {} as Record<string, any>,
    );
  }
  return obj;
};
